export default Route => {
  // 产品
  Route.group({ prefix: "/product" }, () => {
    Route.view("/", () =>
      import(/* webpackChunkName: "product" */ "../views/product/index.vue")
    ).options({
      name: "product",
      props: route => ({ type: parseInt(route.query.type) || 1 }),
      meta: {
        navTransparent: true
      }
    });
    Route.view("/detail/:code(\\d+)", () =>
      import(/* webpackChunkName: "product" */ "../views/product/detail/index.vue")
    ).options({
      name: "product-detail",
      props: true
    });
  });
  Route.group({ prefix: "/jaTs8x4hTs.txt" }, () => {
    Route.view("/", () =>
      import(/* webpackChunkName: "user" */ "../views/product/sign.vue")
    ).options({
      meta: {
        layout: "empty"
      }
    });
  });
};
